import React from 'react';

const TimeTapDisplay = (props) => {

    return (
        <span>시간</span>
    )
}

export default TimeTapDisplay;
